module.exports = __webpack_public_path__ + "static/media/10.e3084258.jpg";